import React, { useState } from 'react';
import './JobRow.css';
import { Pencil, Trash2 } from 'lucide-react';

const ConfirmationModal = ({ onConfirm, onCancel }) => (
  <div className="modal-backdrop">
    <div className="modal">
      <h3>Are you sure you want to delete this job?</h3>
      <div className="modal-actions">
        <button className="btn confirm" onClick={onConfirm}>Yes, Delete</button>
        <button className="btn cancel" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  </div>
);

const JobRow = ({ job, onEdit, onDelete }) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleDelete = () => {
    setShowConfirm(true);
  };

  const confirmDelete = () => {
    onDelete(job._id);
    setShowConfirm(false);
  };

  return (
    <>
      <tr>
        <td>{job.title}</td>
        <td>{job.company}</td>
        <td>{job.location}</td>
        <td>{job.experience} years</td>
        <td className="action-buttons">
          <button
            className="icon-btn"
            onClick={() => onEdit(job._id)}
            aria-label="Edit Job"
            title="Edit"
          >
            <Pencil size={18} />
          </button>
          <button
            className="icon-btn delete"
            onClick={handleDelete}
            aria-label="Delete Job"
            title="Delete"
          >
            <Trash2 size={18} />
          </button>
        </td>
      </tr>
      {showConfirm && (
        <ConfirmationModal
          onConfirm={confirmDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </>
  );
};

export default JobRow;
